export const theme = {
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    color: {
        primary: "#141414",
        secondary: "#cccccc",
        darkSecondary: "#eaeaea",
        grey: "rgba(20,20,20,0.04)",
        helpText: "#b2b9bf",
        blue: "#39f",
        white: "#fff",
        red: "#ff3b30"
    },
    borderColor: {
        primary: "#eaeaea",
        white: "#fff"
    },
    backgroundColor: {
        white: "#000",
        primary: "#ffc72c",
        secondary: "#f6f6f6",
        blue: "#39f",
        red: "#ff3b30",
        grey: "rgba(20,20,20,0.04)",
        lightGrey: "rgba(20, 20, 20, 0.08)",
        darkGrey: "rgba(20,20,20,0.9)",
        callScreenGrey: "#444444",
    },
    breakPoints: [
        "(min-width : 320px) and (max-width: 767px)"
    ]
};
